import { LTLItem, LTLUnitSystem, LTL_UNIT_SYSTEMS } from '../types';

function toInches(value: number, units: LTLUnitSystem): number {
  if (units === LTL_UNIT_SYSTEMS.METRIC) {
    return value / 2.54;
  }

  return value;
}

/**
 * Sum of per-line cubic feet (L×W×H)/1728 × handling units.
 * Used by shipment-level metrics when layout bounding box is disabled.
 */
export function calculateCubicFeetRaw(
  items: LTLItem[],
  units: LTLUnitSystem = LTL_UNIT_SYSTEMS.IMPERIAL,
  customConfig?: {
    heightThresholdInches: number;
    overrideHeightInches: number;
  }
): number {
  if (!items || items.length === 0) {
    return 0;
  }

  let useOverrideHeight = false;
  if (customConfig) {
    useOverrideHeight = items.some((item) => {
      const height = item.height ?? 0;

      if (height <= 0) {
        return false;
      }

      const heightInches = toInches(height, units);
      return heightInches > customConfig.heightThresholdInches;
    });
  }

  const totalCubicFeet = items.reduce((sum, item) => {
    const length = item.length ?? 0;
    const width = item.width ?? 0;
    const height = item.height ?? 0;
    const handlingUnits = item.handlingUnits ?? 1;

    if (handlingUnits <= 0 || length <= 0 || width <= 0 || height <= 0) {
      return sum;
    }

    const lengthInches = toInches(length, units);
    const widthInches = toInches(width, units);
    let heightInches = toInches(height, units);

    if (useOverrideHeight && customConfig) {
      heightInches = customConfig.overrideHeightInches;
    }

    const itemCubicFeet = (lengthInches * widthInches * heightInches) / 1728;

    return sum + itemCubicFeet * handlingUnits;
  }, 0);

  return totalCubicFeet;
}
